/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/ajax';

function getData() {
  return Promise.all([
    get('data/snow.json'),
    get('data/snow-deep-creek.json'),
    get('data/snow-three-mile.json'),
  ]).then(([spencersCreek, deepCreek, threeMileDam]) => ({
    spencersCreek: JSON.parse(spencersCreek).data,
    deepCreek: JSON.parse(deepCreek).data,
    threeMileDam: JSON.parse(threeMileDam).data,
  }));
}

// Create Thunk
export const fetchData = createAsyncThunk('fetchData', async (thunkAPI) => {
  const d = await getData();
  return d;
});

// Slice
const data = createSlice({
  name: 'data',
  initialState: {
    data: [],
    loading: false,
  },
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });
  },
});

export default data;
